import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { RefundRequestBody } from "@shared-kernel/application/ports/student/student-repository";

export const requestRefund = createApiThunk<void, RefundRequestBody>(
  "refunds/requestRefund",
  async (refundRequest: RefundRequestBody, { extra: { studentRepository } }) => {
    return studentRepository!.requestRefund(refundRequest);
  },
);

export const resetRequestRefund = createAction("refunds/resetRequestRefund");
